var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"s-page"},[_vm._t("lateral-panel"),_vm._t("main-panel")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }